module.exports = __webpack_public_path__ + "static/queen-0a4450bb485d58a024833d407e65544f.svg";